import React from "react";
import { Card, Descriptions, Tag } from "antd";
import { formatDateTime } from "../../helpers/date";
import {
  formatCardExpiry,
  formatCardNetwork,
  formatCardProvider,
} from "../../helpers/cardBinding";

// cardBinding is missing from the merchant (not null) when unbound; cardNumber is the legacy SenangPay card
const UserCardBinding = ({ merchant }) => {
  const binding = merchant?.cardBinding;

  return (
    <Card size="small" title="Card Details" className="mb-2">
      <Descriptions size="small" bordered column={2}>
        <Descriptions.Item label="Provider">
          {binding ? (
            <Tag color="blue">{formatCardProvider(binding.provider)}</Tag>
          ) : (
            <Tag>Not bound</Tag>
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Bound At">
          {binding?.boundAt ? formatDateTime(binding.boundAt) : "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Card Network">
          {formatCardNetwork(binding?.cardNetwork) || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Card No.">{binding?.displayPan || "-"}</Descriptions.Item>
        <Descriptions.Item label="Expiry">
          {formatCardExpiry(binding?.expiryMonth, binding?.expiryYear)}
        </Descriptions.Item>
        <Descriptions.Item label="Cardholder Name">{binding?.cardHolderName || "-"}</Descriptions.Item>
        <Descriptions.Item label="Legacy Card (SenangPay)" span={2}>
          {merchant?.cardNumber || "-"}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

export default UserCardBinding;
